export default {
      id: "shipment__pallete-usage",
      viewBox: "0 0 23 19",
      url: __webpack_public_path__ + "img/icons.svg#shipment__pallete",
      toString: function () {
        return this.url;
      }
    }